import { ComparisonSymbolsLastPriceComponent } from "../../components/comparison-symbols-last-price.component";
import { IComponent } from "../../components/component.interface";
import { DrawTradePriceAnnotationComponent } from "../../components/draw-trade-price-annotation.model";
import { DrawingToolsManager } from "../../components/drawing-tools/drawing-tools.manager";
import { IndicatorLastPriceComponent } from "../../components/indicators-last-price.component";
import { LastPriceComponent } from "../../components/last-price.component";
import { TiChartSeriesComponent } from "../../components/ti-chart-series.component";
import { TooltipComponent } from "../../components/tooltip.component";
import { DomEventsSubscribe } from "../../events/dom-events-subscribe";
import { DomExtensions } from "../../extensions/dom.extensions";
import { RequestService } from "../../services/request.service";
import { ScrollMode } from "../enum/scroll-mode.enum";
import { Timeframe } from "../enum/timeframe.enum";
import { IChartContainer } from "./chart-container.interface";
import { IChartDataService } from "./chart-data-service.interface";

export class BaseChartContainer implements IChartContainer {
    public chartService: IChartDataService = null as any;
    public requestService = new RequestService();
    public domEvents = new DomEventsSubscribe();
    public drawingToolsManager: DrawingToolsManager | null = null;

    public components: Array<IComponent> = [];
    public domExtensions = new DomExtensions();
    public body = document.body;

    public marketingWebChartMode = false;
    public pnpMode = false;
    public isPreview = false;
    public disableScrolling = false;
    public scrollMode = ScrollMode.MouseWheel;
    public id = '';
    public basePath = '';
    
    public tiChartSeries: TiChartSeriesComponent | null = null;
    public element: HTMLElement = null as any;
    
    constructor() {
    }

    public getComponentById(id: string): IComponent {
        for (let i = 0; i < this.components.length; i++) {
            if (this.components[i].id === id) {
                return this.components[i];
            }
        }
        return null!;
    }

    public getComponentsByType(type: any): Array<IComponent> {
        const results: Array<IComponent> = [];
        for (let i = 0; i < this.components.length; i++) {
            if (this.components[i] instanceof type) {
                results.push(this.components[i]);
            }
        }
        return results;
    }

    public getComponentsByTypes(types: Array<any>): Array<IComponent> {
        const results: Array<IComponent> = [];
        for (let i = 0; i < this.components.length; i++) {
            for (var j = 0; j < types.length; j++) {
                if (this.components[i] instanceof types[j]) {
                    results.push(this.components[i]);
                }
            }
        }

        return results;
    }

    public getPnPSwitchElement(): HTMLElement {
        return document.body.findFirst('.pnp-switch');
    }

    public setLastPricePositions() {
        this.getComponentsByTypes([
            LastPriceComponent, 
            IndicatorLastPriceComponent,
            ComparisonSymbolsLastPriceComponent,
            DrawTradePriceAnnotationComponent
        ]).forEach((i: IComponent) => {
            if (i instanceof LastPriceComponent) {
                const component = i as LastPriceComponent;
                component.setLastPriceLabelPosition();
            } else if (i instanceof IndicatorLastPriceComponent) {
                const component = i as IndicatorLastPriceComponent;
                component.setLastPriceLabelPosition();
            } else if (i instanceof ComparisonSymbolsLastPriceComponent) {
                const component = i as ComparisonSymbolsLastPriceComponent;
                component.setLastPriceLabelPosition();
            } else if (i instanceof DrawTradePriceAnnotationComponent) {
                const component = i as DrawTradePriceAnnotationComponent;
                component.setPosition();
            }
        });
    }

    public hideTooltip() {
        this.tiChartSeries?.highStockChart?.tooltip?.hide();
        
        const toolTip = this.getComponentsByType(TooltipComponent)[0] as TooltipComponent;
        toolTip?.hide();
    }

    public setComponentStateWhenRequestingNewSymbol(symbol: string, timeframe: Timeframe) {
    }
 
    public toggleChartToPreviewMode(preview: boolean) {
        this.isPreview = preview;
    }
}